module.exports = __webpack_public_path__ + "img/flag2.e32adfa1.png";